import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8900';

const client = axios.create({ baseURL: API_BASE_URL });

export async function createSession(age) {
  const { data } = await client.post('/api/v1/sessions', { age });
  return data;
}

export async function fetchGuardianSpecies() {
  const { data } = await client.get('/api/v1/guardian-species');
  return data;
}

export async function selectGuardian(sessionId, species) {
  const { data } = await client.post(`/api/v1/sessions/${sessionId}/guardian`, { species });
  return data;
}

export async function fetchGuardianDimensions(species, ageBand) {
  const { data } = await client.get(`/api/v1/guardians/${species}/dimensions`, {
    params: { age_band: ageBand },
  });
  return data;
}

export async function fetchSkillPoints(dimension, species, ageBand) {
  const { data } = await client.get('/api/v1/skill-points', {
    params: { dimension, species, age_band: ageBand },
  });
  return data;
}

export async function fetchPuzzles(skillPointId, stage) {
  const { data } = await client.get(`/api/v1/skill-points/${skillPointId}/puzzles`, {
    params: { stage },
  });
  return data;
}

export async function submitAttempt(puzzleId, sessionId, answer, elapsedMs, roundId) {
  const { data } = await client.post(`/api/v1/puzzles/${puzzleId}/attempt`, {
    sessionId,
    answer,
    ...(Number.isFinite(elapsedMs) ? { elapsedMs: Math.round(elapsedMs) } : {}),
    ...(roundId ? { roundId } : {}),
  });
  return data;
}

export async function resumeSession(recoveryCode) {
  const { data } = await client.post('/api/v1/sessions/resume', { recoveryCode });
  return data;
}

// ---------- 账号:主人名 + 暗号 ----------

export async function checkUsername(username) {
  const { data } = await client.get('/api/v1/accounts/check', { params: { username } });
  return data;
}

export async function createAccount(sessionId, { username, password, guardianName }) {
  const { data } = await client.post(`/api/v1/sessions/${sessionId}/account`, {
    username,
    password,
    guardianName,
  });
  return data;
}

export async function login(username, password) {
  const { data } = await client.post('/api/v1/accounts/login', { username, password });
  return data;
}

// ---------- 六艺书院 ----------

export async function fetchLearningMap(sessionId) {
  const { data } = await client.get(`/api/v1/sessions/${sessionId}/learning-map`);
  return data;
}

// 闯关队列;dimension 为空时按学段顺序排全部学科
export async function fetchQueue(sessionId, dimension) {
  const { data } = await client.get(`/api/v1/sessions/${sessionId}/queue`, {
    params: dimension ? { dimension } : {},
  });
  return data;
}

// ---------- 埋点 ----------

export async function reportEvents(events) {
  await client.post('/api/v1/events', { events });
}

export { API_BASE_URL };
